import React, { useEffect, useState  } from 'react';
import ConnectAPI from '../../services/api';
import { Col, Row } from 'reactstrap';
import { Tabs, Table, Button, FilePicker, IconPlus, IconDownload, Select, InlineNotification, ConfirmationModal } from "@veneer/core";
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import moment from 'moment';
import { downloadFile } from "../../services/FileDownloader/FileDownloader";
import InventorReport from './InventoryReport';
const Inventory = ( props ) => {
    const connectApi = new ConnectAPI();
    const [loadingData, setLoadingData] = useState(false);
    const [tabledata, settabledata]=useState([]);
    const [columsdata, setcolumsdata]=useState([]);
    const [t, i18n] = useTranslation();
    const [userdata, setuserdata]=useState( JSON.parse(localStorage.getItem("currentUser")));
    const [datafull, setdatafull]=useState([]);
    const [activeTabIndex, setactiveTabIndex] = useState(0);

   
    function configdate(date, datecompare){
        var text="";
        if(date=="N/A"){
            text="N/A";
        }else{
            if(moment(datecompare).isSameOrAfter(moment(date))){
                text=moment(date).format("DD-MMM-YY")
            }else{
                text=<label  style={{color: 'red'}}>{moment(date).format("DD-MMM-YY")}</label>
            }
        }
        return text;
    }
    function configsecondheader(element){
        var text="";
        text=<label  style={{fontWeight: 'bold'}}>{element}</label>
        return text;
    }
    useEffect(() => {
        
        const fetchData = async () => {
            connectApi.get( "api/Channels/inventoryViewData", '', dataResponseLoad ).catch((error) => {
                setLoadingData(false);
                Swal.fire( "Error " + error.response?.status, error.response?.data, "error" );
            });
            setLoadingData(true);
        };

        const dataResponseLoad = (status, data) => {
            setdatafull(data["inventories"]);
            data["datesinventory"].forEach(x=>{
                x.dateSellout= moment(x.dateSellout).format("YYYY/MMM");
                x.dateSubmission= moment(x.dateSubmission).format("DD-MMM-YY");
            });

            data["datesinventory"].reverse();
            var data2=[ {id:'title',label:t('inventoryTableHeader1') }
            ];
            data["datesinventory"].forEach(element => {
                data2.push({ id: moment(element["dateSellout"]).format("MMM"), label: moment(element["dateSellout"]).format("MMM")+"-"+ moment(element["dateSellout"]).year()});
            });

            let itemsCustomersFilter=[
                {
                    title: configsecondheader(t('inventoryTableHeader2')), 
                    Jan: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Jan')[0].dateSubmission), 
                    Feb: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Feb')[0].dateSubmission), 
                    Mar: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Mar')[0].dateSubmission), 
                    Apr: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Apr')[0].dateSubmission), 
                    May: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'May')[0].dateSubmission), 
                    Jun: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Jun')[0].dateSubmission), 
                    Jul: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Jul')[0].dateSubmission), 
                    Aug: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Aug')[0].dateSubmission), 
                    Sep: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Sep')[0].dateSubmission), 
                    Oct: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Oct')[0].dateSubmission), 
                    Nov: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Nov')[0].dateSubmission), 
                    Dec: configsecondheader(data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Dec')[0].dateSubmission)
                }
            ];
           
            data["inventories"].forEach(element=>{
                itemsCustomersFilter.push({
                    title: element["customerName"]+"  ( "+element["idCustomer"]+" )", 
                    Jan: configdate(element["date1"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Jan')[0].dateSubmission), 
                    Feb: configdate(element["date2"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Feb')[0].dateSubmission),
                    Mar: configdate(element["date3"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Mar')[0].dateSubmission),
                    Apr: configdate(element["date4"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Apr')[0].dateSubmission),
                    May: configdate(element["date5"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'May')[0].dateSubmission),
                    Jun: configdate(element["date6"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Jun')[0].dateSubmission),
                    Jul: configdate(element["date7"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Jul')[0].dateSubmission),
                    Aug: configdate(element["date8"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Aug')[0].dateSubmission),
                    Sep: configdate(element["date9"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Sep')[0].dateSubmission),
                    Oct: configdate(element["date10"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Oct')[0].dateSubmission),
                    Nov: configdate(element["date11"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Nov')[0].dateSubmission), 
                    Dec: configdate(element["date12"],data["datesinventory"].filter((z) => moment(z.dateSellout).format("MMM") == 'Dec')[0].dateSubmission)
                })
            })
            settabledata(itemsCustomersFilter === undefined ? [] : itemsCustomersFilter );
            setcolumsdata(data2);
        };
        fetchData();
    },[]);

    const RenderUploadData = () => {
        const [showNotification, setShowNotification] = useState(false);
        const [confirButton, setConfirButton] = useState(false);
        const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
        const [file, setFile]=useState(null);
        const [loadingbutton,setloadingbutton]=useState(false);
        function handleChange(event) {
            setFile(event.target.files[0]);
        }
        function submitFile(  ){
            let data = new FormData();
            setloadingbutton(true);
            data.append("file", file);
            connectApi.post(
                "api/Channels/uploadInventoryData", data, handleReloadData
            ).catch((error) => {
                if (error?.response?.status==502) {
                    setConfirButton(true);
                    setloadingbutton(false);
                } else {
                    setloadingbutton(false);
                    Swal.fire(
                        "Error ", error?.response?.data,"error"
                    );
                }
            });
        }
        const handleReloadData = (status,data) => {
            if (status==200) {
                setloadingbutton(false);
                setNotificationDetails({
                    title: t("notifyAllCorrect"),
                    type: 'positive',
                    description: ''
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                setloadingbutton(false);
                Swal.fire(
                    "Error " + data.status,
                    data.data,
                    "error"
                );
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setShowNotification(true);
        }
        // Verifica si es Administrador, de lo ontrario muestra solo lo del canal
        // dos vistas una para los canales y otra para los administradores        
        return (
            <div>
                
                    <Row>
                    <Col >
                        <div 
                            style={{
                                marginTop: "20px",
                                marginLeft: "30%",
                                width: "250px",
                            }}
                        >
                            <div><h5>Updated file</h5></div>
                            <FilePicker 
                                id="Files"
                                accept=".xlsx,.xls,.csv"
                                onChange={handleChange}
                            />
                            <Button 
                                style={{
                                    position: "absolute",
                                    height: "35px",
                                    width: "50px",
                                    marginLeft: "252px",
                                    marginTop: "-35px"
                                }}
                                loading={loadingbutton}
                                leadingIcon={<IconPlus size={30} filled />}
                                onClick={() => submitFile()}
                                disabled={file?false:true}
                            />
                            <Button 
                                style={{
                                    marginTop: "8px",
                                }}
                                appearance="secondary" 
                                leadingIcon={<IconDownload />} 
                                onClick={() => {downloadFile("InventoryTemplate.xlsx");}}
                                disabled={file?true:false}
                            >
                                {t('downloadTemplate')}
                            </Button>
                            {showNotification ? (
                                <div className="show-animated" >
                                    <InlineNotification
                                        title={notificationDetails.title}
                                        type={notificationDetails.type}
                                        description={notificationDetails.description}
                                        onClose={() => { setShowNotification(false) }}
                                    /> <br />
                                </div>
                            ) : undefined}
                        </div>
                    </Col>
                </Row>
                
                <div style={{ marginTop: "20px"}} >
                    <Table 
                        columns={columsdata}
                        data={tabledata}
                        //loading={loadingData}
                    />
                </div>
        </div>
        );
    
    }
    
    let list = [
        { id: 0, label: t('Inventory'), content: <div><RenderUploadData/></div>}
    ];

    if (![9,10,11,12].includes(userdata["idRole"])){
        list.push( { id: 1, label: "Report", content: <div><InventorReport data={datafull}/></div>})
    }

    const selectTab = (event) => (index) => {
        setactiveTabIndex(index);
    };
    return (<>
        <Tabs
            controlId="default"
            onChangeTab={selectTab()}
            selectedTabId={activeTabIndex}
            tabs={list}
        />
    </>);
}

export default Inventory;